import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppStateService } from '../../../services/app-state.service';
import { KeycloakService } from '../../../services/keycloak.service';
import { isNullOrUndefined } from '../../../shared/common-utils';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private isBrowser: boolean;

  userInfo: any;
  loggedIn: boolean = false;
  token: string = "null";
  authState = new BehaviorSubject<boolean>(this.loggedIn);

  constructor(
    private keycloakSrv : KeycloakService,
    private appState:AppStateService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {   
    this.isBrowser = isPlatformBrowser(this.platformId); 
      if(this.isBrowser) {
      const token = localStorage.getItem('token')?localStorage.getItem('token'): null;
      const userInfo = this.appState.getUserInfoFromLocalStorage();
      console.log("userInfo==", userInfo)
      this.setUserInfo(userInfo, (token as string));
    }
  }

  setUserInfo(userInfo: any, token: string) {
    this.userInfo = userInfo;
    this.token = token;
    
    this.appState.setUserInfoInLocalStorage(userInfo);
    
    this.loggedIn = !!userInfo && !!userInfo.userId && !!this.token;
    this.authState.next(this.loggedIn); 
    if(this.loggedIn){
      this.setKeycloakInstance();
    }
    if(this.isBrowser) {
      localStorage.setItem('loggedIn', JSON.stringify(this.loggedIn));
    }
    
  }

  setKeycloakInstance(){
    console.log("Kkk1==", this.appState.getKeyCloakInstance())
    console.log("Kkk2==", this.keycloakSrv.getKeycloakInstance())
      const keyCloakAuth = this.appState.getKeyCloakInstance()
        ? this.appState.getKeyCloakInstance()
        : this.keycloakSrv.getKeycloakInstance();
        
        
      console.log("Kkk3==", keyCloakAuth)
        


      if (isNullOrUndefined(this.appState.getKeyCloakInstance())) {
            console.log("Kkk3==", this.keycloakSrv.getKeycloakInstance())
        this.appState.setKeyCloakInstance(keyCloakAuth);
    }
  }

  isLoggedIn(): boolean {
    return !!this.loggedIn;
  }

  setManualLogin() {
    this.loggedIn = true
  }

  isPromptToChangePswd ():boolean{
    return this.loggedIn ? this.userInfo.promptForChangePassword : false
  }

  getUserId(): string | null {
    return this.loggedIn ? this.userInfo.userId : null;
  }

  getToken(): string | null {
    return this.loggedIn ? localStorage.getItem('token') : null;
  }

   async getAccessToken(): Promise<string | null> {
    // return this.getToken() ?? await this.keycloakSrv.getToken();
    return await this.keycloakSrv.getToken();

  }

  getRefreshToken() : string | null {
    return this.loggedIn ? localStorage.getItem('refreshToken') : null;
  }

  getUserName(){
    return this.loggedIn ? this.userInfo.username : null;
  }

  handleError(error: any){
    if(error.status == 0){
      return 'Server Unreachable';
    }
    else if(error.status == 401){
      return 'Incorrect login credentials i.e. user or password!'
    }
    else if(error. status == 403){
      return 'Forbidden'
    }
    else if(error.status == 404){
      return 'Not Found'
    }
    else if(error.status == 500){
      return 'Internal Server Error'
    }
    return 'Error while API call'
  }
}

